
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as CurrencyResolver from "@/utils/currencyResolver";

@Component
export default class MarketSlot extends Vue {
  // 📦 Currency pair that should be displayed (BTC:USDT for example)
  @Prop({ default: undefined })
  public market!: string;

  // 🚩 Flag for whether the slot should be denser in size
  @Prop({ default: false })
  public dense!: boolean;

  @Prop({ default: false })
  public singleToken!: boolean;

  /**
   * 🔨 Returns the image url needed for the primary currency
   */
  private getPrimaryCurrencyUrl(market: string): string {
    return this.getCurrencyUrl(market.split(":")[0]);
  }

  /**
   * 🔨 Returns the image url needed for the secondary currency
   */
  private getSecondaryCurrencyUrl(market: string): string {
    return this.getCurrencyUrl(market.split(":")[1]);
  }

  /**
   * 🔨 Returns the proper image url based on the currency type
   *  Currently all images are ffetched from TradingView's servers
   */
  private getCurrencyUrl(currency: string) {
    switch (CurrencyResolver.resolveCurrencyType(currency)) {
      // Is a crypto currency (BTC, LTC, etc)
      case CurrencyResolver.CurrencyType.CryptoCurrency: {
        return (
          "https://s3-symbol-logo.tradingview.com/crypto/XTVC" +
          CurrencyResolver.resolveCurrency(currency) +
          ".svg"
        );
      }
      // Is a normal currency (dollars, euros, etc)
      case CurrencyResolver.CurrencyType.NormalCurrency: {
        return (
          "https://s3-symbol-logo.tradingview.com/country/" +
          CurrencyResolver.resolveCurrency(currency) +
          ".svg"
        );
      }
    }
  }
}
